// extracted by mini-css-extract-plugin
export default {"mainDiv":"ContestClosePopup_mainDiv__mCdWY","container":"ContestClosePopup_container__HSw7a","button":"ContestClosePopup_button__DFZRb"};